import { render, staticRenderFns } from "./ScreenerList.vue?vue&type=template&id=0563f1dd&scoped=true&"
import script from "./ScreenerList.vue?vue&type=script&lang=js&"
export * from "./ScreenerList.vue?vue&type=script&lang=js&"
import style0 from "./ScreenerList.vue?vue&type=style&index=0&id=0563f1dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563f1dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
